import { render, staticRenderFns } from "./Schedules.vue?vue&type=template&id=6c4e1114&scoped=true"
import script from "./Schedules.vue?vue&type=script&lang=js"
export * from "./Schedules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4e1114",
  null
  
)

export default component.exports